export function LockIcon({ size = 24 }) {
	return (
		<svg
			width={size}
			height={size}
			// viewBox={`0 0 ${size} ${size}`}
			viewBox="0 0 24 24"
			fill='none'
			stroke='currentColor'
			stroke-width='2'
			stroke-linecap='round'
			stroke-linejoin='round'
		>
			<path
				stroke='none'
				d='M0 0h24v24H0z'
				fill='none'
			/>
			<path d='M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6z' />
			<path d='M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0' />
			<path d='M8 11v-4a4 4 0 1 1 8 0v4' />
		</svg>
	)
}

export function UnLockIcon(props: any) {
	return (
		<svg
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'
			stroke='currentColor'
			stroke-width='2'
			stroke-linecap='round'
			stroke-linejoin='round'
		>
			<path
				stroke='none'
				d='M0 0h24v24H0z'
				fill='none'
			/>
			<path d='M3 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z' />
			<path d='M9 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0' />
			<path d='M13 11v-4a4 4 0 1 1 8 0v4' />
		</svg>
	)
}
